import { getLocale } from "../runtime";

const sv_blogposts = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Bloggartiklar`
};

const blogposts = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_blogposts(inputs)
	return "blogPosts";
};

export { blogposts as "blogPosts" };